import { useServerData } from '../../context/ServerDataContext';
import useRedesignAccount from '../../services/useRedesignAccount';

const FALLBACK_MAIN_PAGE_URL = '/';

function useHeaderProps() {
    const { locale, country, appSettings } = useServerData();
    const account = useRedesignAccount();

    return {
        locale,
        country,
        mainPageUrl: appSettings.mainPageUrl || FALLBACK_MAIN_PAGE_URL,
        buyerSpaUrl: appSettings.buyerSpaUrl || '',
        adminSpaUrl: appSettings.adminSpaUrl || '',
        availableLocales: appSettings.availableLocales || [],
        availableCountries: appSettings.availableCountries || [],
        account: account.role === null ? null : account,
    };
}

export default useHeaderProps;
